import { makeStyles } from "@mui/styles";

export const useStyles = makeStyles((theme) => ({
  containerLabel: {
    paddingLeft: "0 !important",
    marginBottom: "1px !important",
  },
}));
